export const Errors = {
  mandatory: 'This field is required',
};
